import { Component, OnInit } from "@angular/core";
import { LoaderService, Message } from "@stdoutsrl/design-kit";
import { DashboardService } from "../../service/dashboard.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styles: [],
  standalone: false,
})
export class DashboardComponent implements OnInit {
  constructor(
    private loader: LoaderService,
    private message: Message,
    private dashboardService: DashboardService
  ) {}
  dashboardData = {
    noOfBookings: 0,
    noOfCompanies: 0,
    noOfSalons: 0,
    noOfUsers: 0,
  };

  ngOnInit(): void {
    this.getDashboard();
  }

  getDashboard() {
    this.dashboardService.getDashboard().subscribe({
      next: (value: any) => {
        this.dashboardData = value;
      },
      error: (value) => {},
    });
  }
}
